var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container mt-2 mb-3 mb-sm-0"},[_c('h1',{staticClass:"header"},[_vm._v("Verify your identity")]),_c('h4',{staticClass:"sub-header mt-2"},[_vm._v("Let’s verify your identity so you can access the Autodesk employee network.")])])
}]

export { render, staticRenderFns }